import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5040Service } from '../../CSPService/CSP5040/csp5040.service';
import { Csp5040Class } from '../../CSPClass/CSP5040/csp5040-class';
@Component({
  selector: 'kt-csp5040-view',
  templateUrl: './csp5040-view.component.html',
  styleUrls: ['./csp5040-view.component.scss']
})
export class Csp5040ViewComponent implements OnInit {

   lblPageTitle: string = "";
   OutstandingFeeList: any[] = [];
   showOutstandingInfo = false;
   showOutstandingDetails = false;
  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5040ViewComponent>, private objCsp5040Service:Csp5040Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
     this.onGetDatas();
  }

 onGetDatas() {
     if (localStorage.getItem('currentUser') != null) {
            var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
            var classobj = new Csp5040Class();
            classobj.UserNam= userLoginDetails.UserNam;
                classobj.ShowAllFlag = 2;
            this.objCsp5040Service.Outstanding(classobj).subscribe((data) => {         
              this.OutstandingFeeList = data || []; 
            });
            this.changeDetectorRef.detectChanges();
          }
        }

indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}

OutstandingFeeTotalAmountToPay(): number {
  return this.OutstandingFeeList.reduce((sum, item) => {
    const value = Number(String(item.FeeAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OutstandingFeeTotalAmountPaid(): number {
  return this.OutstandingFeeList.reduce((sum, item) => {
    const value = Number(String(item.PaidAmount).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

OutstandingFeeTotalAmountDue(): number {
  return this.OutstandingFeeList.reduce((sum, item) => {
    const value = Number(String(item.amount_to_pay).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}
  onClose() {
  if (this.dialogRef) {
  this.dialogRef.close();
  }
}
   getComponentTitle() {
    let result =  "Outstanding Fee Details";
    return result;
   }
   toggleOutstandingDetails(){
    this.showOutstandingDetails = !this.showOutstandingDetails;
    const ShowAllFlag = this.showOutstandingDetails ? 1 : 2;
    this.getOutstandingData(ShowAllFlag);
  }

getOutstandingData(ShowAllFlag: number){
  if (localStorage.getItem('currentUser') != null) {
    const userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
    const classobj = new Csp5040Class();
    classobj.UserNam = userLoginDetails.UserNam;
    classobj.ShowAllFlag = ShowAllFlag;
    this.objCsp5040Service.Outstanding(classobj).subscribe((data) => {
        this.OutstandingFeeList = data || [];
      });
  }
}
}
